<template>
  <section>
    <!-- Listing Header -->
    <measurements-header @search="search" @add="addMeasurement" />
    <!-- Table Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="measurements"
        sortBy="name"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center">
            <input
              v-model="selected"
              :value="props.row.id"
              type="radio"
              class="z-checkbox-small-centered"
              @change="confirmInitial"
            />
          </td>
          <td class="z-column-110-center">
            {{ formatDate(props.row.created_at) }}
          </td>
          <td>
            {{ formatNumber(props.row.BodyWeight, 1) }}
          </td>
          <td class="z-column-140-center">
            {{ formatNumber(props.row.BodyFat, 1) }}
          </td>
          <td class="z-column-80-center">
            {{ formatNumber(props.row.BMI, 1) }}
          </td>
          <td class="z-column-80-center">
            {{ formatNumber(props.row.BMR, 0) }}
          </td>
          <td class="z-column-110-center">
            {{ formatNumber(props.row.BoneKg, 1) }}
          </td>
          <td class="z-column-110-center">
            {{ formatNumber(props.row.MuscleKg, 1) }}
          </td>
          <td class="z-column-100-center">
            {{ formatNumber(props.row.WaterPct, 1) }}
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <confirm-initial
      :show="actionConfirmInitial"
      :confirmTitle="confirmTitleInitial"
      :confirmAction="confirmActionInitial"
      :confirmQuestion="confirmQuestionInitial"
      @closing="closeModal"
      @proceed="performInitial"
    />
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import MeasurementsHeader from './measurements-header'
import ConfirmInitial from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'bodycomp-measurements',
  components: {
    ZTable,
    MeasurementsHeader,
    ConfirmInitial,
  },
  data() {
    return {
      selected: null,
      confirmTitleInitial: 'Confirm Initial',
      confirmActionInitial: 'Confirm',
      confirmQuestionInitial:
        'Are you sure you wish to set this measurement as your Initial Measurement?',
      actionConfirmInitial: null,
    }
  },
  async mounted() {
    await this.search()
  },
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    ...mapGetters('bodycomposition', ['measurements', 'pager']),
    tableColumns() {
      let columns = [
        {
          field: 'Id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'created_at',
          label: 'Date',
          sortable: false,
          class: 'z-column-110-center',
        },
        {
          field: 'BodyWeight',
          label: 'Body Weight (lbs)',
          sortable: false,
        },
        {
          field: 'BodyFat',
          label: 'Body Fat',
          sortable: false,
          class: 'z-column-120-center',
        },
        {
          field: 'BMI',
          label: 'BMI',
          sortable: false,
          class: 'z-column-80-center',
        },
        {
          field: 'BMR',
          label: 'BMR',
          sortable: false,
          class: 'z-column-80-center',
        },
        {
          field: 'BoneKg',
          label: 'Bone (%)',
          sortable: false,
          class: 'z-column-110-center',
        },
        {
          field: 'MuscleKg',
          label: 'Muscle (%)',
          sortable: false,
          class: 'z-column-110-center',
        },
        {
          field: 'WaterPct',
          label: 'Water (%)',
          sortable: false,
          class: 'z-column-100-center',
        },
      ]
      return columns
    },
  },
  methods: {
    ...mapActions('bodycomposition', [
      'getBodyComposition',
      'getMeasurements',
      'saveInitialMeasurement',
    ]),
    formatDate(date) {
      let _date = null
      if (date) {
        _date = moment(new Date(date)).format('MM/DD/YYYY')
      }
      return _date
    },
    formatNumber(value, place) {
      let data = null
      if (value) {
        data = parseFloat(value).toFixed(place)
      }
      return data
    },
    closeModal() {
      this.actionConfirmInitial = null
      this.selected = null
    },
    async search() {
      this.selected = null
      await this.getMeasurements({
        userid: this.member.id,
        page: this.pager.page,
        pageSize: this.pager.pageSize,
        sortBy: this.pager.sortBy,
        orderBy: this.pager.orderBy,
        search: this.pager.search,
      })
      if (this.measurements) {
        let found = this.measurements.find((x) => x.IsInitial === 1)
        if (found) {
          this.selected = found.id
        }
      }
      window.app.$forceUpdate()
    },
    addMeasurement() {},
    confirmInitial() {
      this.$nextTick(() => {
        this.actionConfirmInitial = true
      })
    },
    async performInitial() {
      if (this.selected) {
        console.log('Setting Initial', this.selected)
        this.actionConfirmInitial = null
        let data = {
          id: this.selected,
          userid: this.member.id,
        }
        await this.saveInitialMeasurement(data)
        data = {
          id: this.member.id,
          date: moment().format('YYYY-MM-DD'),
        }
        await this.getBodyComposition(data)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
  width: 100%;
}
</style>
